<template>
  <div class="card-container">
    <Card class="menu-card">
      <template #title>
        <div class="card-title">Ansicht wählen</div>
      </template>
      <template #content>
        <Button @click="router.push({ name: RouteNames.STOCK })">
          Lagerstand
        </Button>
        <Button @click="router.push({ name: RouteNames.ONLOAN })">
          Leihartikel im Umlauf
        </Button>

        <Button
          v-if="showMovementsButton"
          @click="router.push({ name: RouteNames.MOVEMENTS })"
        >
          Alle Artikelbewegungen
        </Button>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
  import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";
  import { useRouter } from "vue-router";
  import { RouteNames } from "@/router/RouteNames";
  import Button from "primevue/button";
  import Card from "primevue/card";
  import { useIsAuthenticated } from "@/composition-api/useIsAuthenticated";
  import { useUserProfile } from "@/composition-api/useUserProfile";
  import type UserInfo from "@/utils/UserInfo";

  const router = useRouter();
  const isAuthenticated = useIsAuthenticated();
  const currentInstance = getCurrentInstance();

  const currentUserId = ref<string>();
  const getUserInfo = ref<(id: string) => { value: UserInfo | undefined }>();

  //TODO: Während Testphase bzw. Rollout an Instandhaltungsmitarbeiter "Alle Artikelbewegungen" nur für eingeschränkten Personenkreis. Nach Test evtl. dynamische Gruppe.
  const userDetails = computed(() => {
    if (currentUserId.value && getUserInfo.value) {
      return getUserInfo.value(currentUserId.value).value;
    }
    return undefined;
  });

  const allowedRoles = [
    "Werkstättenleiter",
    "Leiter",
    "Technik",
    "Obermonteur",
    "Magazin",
    "Technischer Projektkoordinator Rail",
    "Solution Architect",
    "Software Developer",
    "Software Engineer",
  ];

  const showMovementsButton = computed(() => {
    const jobTitle = userDetails.value?.jobTitle;
    if (!jobTitle) return false;

    return allowedRoles.some((role) =>
      jobTitle.toLowerCase().includes(role.toLowerCase()),
    );
  });

  onMounted(() => {
    watch(
      isAuthenticated,
      () => {
        if (isAuthenticated.value) {
          const userProfile = useUserProfile(currentInstance);
          getUserInfo.value = userProfile.getUserInfo;

          watch(userProfile.currentUserId, (v) => (currentUserId.value = v), {
            immediate: true,
          });
        }
      },
      { immediate: true },
    );
  });
</script>

<style scoped lang="scss">
  .card-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem 2rem;
    flex-wrap: wrap;

    .menu-card {
      text-align: center;
    }

    .card-title {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      font-size: 1em;
      font-weight: bold;
    }

    button {
      margin: 0.5rem 0 0 1rem;
    }
  }
</style>
